// extracted by mini-css-extract-plugin
module.exports = {"hero":"__404_hero__1Vlku","text":"__404_text__3Dh_o","title":"__404_title__3q3ww","copy":"__404_copy__2jJWZ","image":"__404_image__23blM","mobile":"__404_mobile__2_pyo"};